export const ACTIVE_EMAIL_STEP = 'ACTIVE_EMAIL_STEP';
export const SEARCH_CRITERIA_STEP = 'SEARCH_CRITERIA_STEP';
export const FILE_UPLOAD_STEP = 'FILE_UPLOAD_STEP';
export const NEW_EMAIL_STEP = 'NEW_EMAIL_STEP';
export const CONFIRMATION_STEP = 'CONFIRMATION_STEP';
